import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixPopover from "@radix-ui/react-popover";
const popover = tailwindVariants({
    base: "z-portal max-h-[calc(var(--radix-popover-content-available-height)-32px)] w-full overflow-y-auto rounded bg-surface-1 shadow-popover outline-none radix-side-bottom:animate-slide-up radix-side-top:animate-slide-down dark:border dark:border-grey-5",
    variants: {
        size: {
            small: "min-w-[216px] p-1.5",
            large: "min-w-[240px] p-2"
        }
    },
    defaultVariants: {
        size: "small"
    }
});
export const Popover = (param)=>{
    let { align = "start", children, className, collisionPadding = 8, defaultOpen, modal, onOpenChange, open, side = "bottom", sideOffset = 8, size = "small", trigger, container, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(RadixPopover.Root, {
        defaultOpen: defaultOpen,
        open: open,
        onOpenChange: onOpenChange,
        modal: modal,
        children: [
            /*#__PURE__*/ _jsx(RadixPopover.Trigger, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ _jsx(RadixPopover.Portal, {
                container: container,
                children: /*#__PURE__*/ _jsx(RadixPopover.Content, {
                    align: align,
                    className: popover({
                        size,
                        class: className
                    }),
                    collisionPadding: collisionPadding,
                    side: side,
                    sideOffset: sideOffset,
                    ...restOfProps,
                    children: children
                })
            })
        ]
    });
};
